import React from 'react'

import { Portlet } from '_zari/core'

import * as CodigosTransaccionesConstant from 'constants/codigosTransacciones'

import NuevaMainForm from './mainForm'

const portletBreadcrumbs = [
  {
    name: 'Ingreso Guias - Compras',
    path: `/${CodigosTransaccionesConstant.COMPRASINGRESOGUIA_LISTA}`
  },
  {
    name: 'Nueva'
  }
]

const NuevoIngresoGuiaPage = ({ history }) => {
  return (
    <>
      <Portlet>
        <Portlet.Header title='Ingreso Guias - Compras' breadcrumbs={portletBreadcrumbs} />
        <Portlet.Body>
          <NuevaMainForm history={history} />
        </Portlet.Body>
      </Portlet>
    </>
  )
}

export default NuevoIngresoGuiaPage
